module.exports = __webpack_public_path__ + "static/media/icons.faff9214.woff";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff
// module id = 404
// module chunks = 0